import { observer } from "mobx-react"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { ActionLockedIconWithTooltip } from '../../../../common/components/ActionLocked/ActionLockedIconWithTooltip'
import { ROUTES } from "../../../../common/constants/routes.const"
import { navigateToUrl } from "../../../../common/utils/navigation.utils"
import { useStore } from "../../../app/data/root.store"
import { useAnalytics } from "../../../app/data/AnalyticsProvider"
import { VaultUploadButtonText } from "../VaultPage/Vault.styles"
import { VaultSearch } from "../VaultSearch/VaultSearch"
import { VaultButtonBlack, VaultButtonsWrapper, VaultButtonTransparent, VaultHeaderWrapper } from "./VaultHeader.styles"

export const VaultHeader = observer(({ onUploadClick }) => {
    const { userStore } = useStore();
    const { mixpanelTrack } = useAnalytics();
    const history = useHistory();
    
    const onClickCreateReports = () => {
        mixpanelTrack('CTA Clicked', {
            cta_text: 'Create reports',
            destination: ROUTES.reports.url,
            location: 'vault',
            url: window.location.href,
            type: 'Button'
        });
        navigateToUrl(history, ROUTES.reports.url);
    };

    const handleUploadClick = () => {
        mixpanelTrack('CTA Clicked', {
            cta_text: 'Upload files',
            destination: 'upload component',
            location: 'vault',
            url: window.location.href,
            type: 'Button'
        });
        onUploadClick();
    };

    return (
        <VaultHeaderWrapper>
            <VaultSearch />
            <VaultButtonsWrapper>
                <VaultButtonTransparent onClick={onClickCreateReports}>
                    <div>Create reports</div>
                    <VaultCreateReportsSvg />
                </VaultButtonTransparent>
                <VaultButtonBlack onClick={handleUploadClick}>
                    <VaultUploadSvg />
                    <VaultUploadButtonText>
                        Upload files
                        {userStore.isActionBlockedByRole('addVaultFile') && <ActionLockedIconWithTooltip iconColor={'#FFF'} isRoleBlocked={true} marginLeft={'0px'} />}
                    </VaultUploadButtonText>
                </VaultButtonBlack>
            </VaultButtonsWrapper>
        </VaultHeaderWrapper>
    )
})

const VaultUploadSvg = () => {
    return (
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.7207 14.4998C21.151 14.5001 21.5 14.8394 21.5 15.2576V16.7126C21.4998 18.8041 19.7544 20.4994 17.6016 20.4998H6.39844C4.2455 20.4995 2.50025 18.8041 2.5 16.7126V15.2576C2.5 14.8394 2.84886 14.5 3.2793 14.4998C3.70996 14.4998 4.05957 14.8392 4.05957 15.2576V16.7126C4.05982 17.9674 5.10682 18.9849 6.39844 18.9851H17.6016C18.8931 18.9848 19.9402 17.9673 19.9404 16.7126V15.2576C19.9404 14.8392 20.29 14.4998 20.7207 14.4998ZM12.001 4.74976C12.1672 4.74976 12.32 4.80567 12.4443 4.89722C12.466 4.91311 12.4866 4.93047 12.5068 4.94897C12.5181 4.95928 12.5295 4.96926 12.54 4.98022L16.6426 9.08276C16.9355 9.37566 16.9355 9.85042 16.6426 10.1433C16.3497 10.436 15.8748 10.4361 15.582 10.1433L12.751 7.31226V15.3669C12.751 15.7812 12.4152 16.1169 12.001 16.1169C11.5869 16.1168 11.251 15.7811 11.251 15.3669V7.31226L8.41992 10.1433C8.12701 10.436 7.65219 10.4361 7.35938 10.1433C7.06662 9.85049 7.06674 9.37566 7.35938 9.08276L11.4609 4.98022C11.4723 4.96843 11.485 4.95806 11.4971 4.94702C11.5161 4.92972 11.5354 4.91319 11.5557 4.89819C11.6803 4.80575 11.8339 4.74982 12.001 4.74976Z" fill="white" />
        </svg>
    )
}

const VaultCreateReportsSvg = () => {
    return (
        <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.561 10.75C12.561 10.75 17.6796 10.75 19.9982 10.75C19.9982 13.0686 19.9982 18.1872 19.9982 18.1872" stroke="#1A1B1D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.5 20.2539L19.675 11.0789" stroke="#1A1B1D" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    )
}